import { PriceWarningList, Warning, WarningKeyEnum } from "./models/ticketselectionwarning";
import { AddToCartItem, AddToCartPackageItem, getItemPriceIds } from "../stores/add-to-cart-stores/models/add-to-cart-items";
import { produce } from "immer";
import { TicketModel } from "../mvcapi/models/buyticket/submodels";
import { values } from "lodash";

/**
 * Keep only the first warning of each price to keep it simple on screen for the users
 * @param warnings 
 * @returns 
 */
export function keepOnlyFirstWarningsOfEachPrice(warnings: PriceWarningList[]) {
    return warnings.map(priceWithWarnings => {
        return produce(priceWithWarnings, d => {
            if(d.warnings.length > 1)
                d.warnings = [ d.warnings[0] ];
        });
    });
}

export function distributeWarningsOnItems(items: AddToCartItem[], warnings: PriceWarningList[]) {
    // For each warnings, spread them in the right item IDs according to their price group and the distribution rules
    const warningsByItemId: { [ item: string ]: Warning[] } = {};

    for(const priceWithWarnings of warnings) {
        
        for(const warning of priceWithWarnings.warnings) {
            // Select the items that are affected by this warning
            const affectedItemIds = items.filter(item => getItemPriceIds(item).some(priceId => priceId === priceWithWarnings.priceId));

            if(affectedItemIds.length === 0) 
                continue;

            // Distribute this warning on the item according to type of this warning
            distributeAWarningOnAffectedItems(warningsByItemId, affectedItemIds, warning);
        }
    }

    return warningsByItemId;
}


export function distributeAWarningOnAffectedItems(warningsByItemId: { [ item: string ]: Warning[] }, affectedItems: AddToCartItem[] | AddToCartPackageItem[], warning: Warning) {
    const itemIds = affectedItems.map(item => item._id);

    if(warning.key === WarningKeyEnum.MISSING_QTY) {
        const itemId = itemIds[itemIds.length - 1];
        if(!warningsByItemId[itemId])
            warningsByItemId[itemId] = [];
        warningsByItemId[itemId].push(warning);
    } else if(warning.key === WarningKeyEnum.QTY_TO_REMOVE) {
        // warning.qtyToRemove
        // Add the warning to the number of tickets to remove at the end of the list.
        for(let i = itemIds.length - warning.qtyToRemove; i < itemIds.length; i++) {
            const itemId = itemIds[i];
            if(!warningsByItemId[itemId])
                warningsByItemId[itemId] = [];

            warningsByItemId[itemId].push(warning);
        }
    } else {
        for(const itemId of itemIds) {
            if(!warningsByItemId[itemId])
                warningsByItemId[itemId] = [];

            warningsByItemId[itemId].push(warning);
        }
    }

    return warningsByItemId;
}

export function getTicketModelsByEventDateId (tickets: TicketModel[]): { [eventDateId: number]: TicketModel[] } {
    // creer un dictionnaire de tickets par eventDateId
    const ticketsByEventDateId = tickets.reduce((acc, ticket) => {
        if (!acc[ticket.EventDateID]) 
            acc[ticket.EventDateID] = [] as TicketModel[];

        acc[ticket.EventDateID].push(ticket);
        return acc;
    }, {} as { [eventDateId: number]: TicketModel[] });

    return ticketsByEventDateId;
}

export function getMaximumNbrTicketsByEventDateId(ticketsByEventDateId: { [eventDateId: number]: TicketModel[] }) {
    // Trouver le nombre maximum de billets par eventDateId
    let nbrPackageItems = 0; 
    values(ticketsByEventDateId).forEach((tickets) => {
        if(tickets.length > nbrPackageItems) 
            nbrPackageItems = tickets.length;
    });

    return nbrPackageItems;
}


// export function GetTicketLabelInfos(selectedTickets: SelectedTicketInfo[], priceListWarnings: PriceWarningList[]): TicketLabelInfo[] {
//     const ticketInfos = ConvertToTicketLabelInfo(selectedTickets, priceListWarnings);
//     return reduceTicketListWarningsForUX(ticketInfos);
// }

// export function ConvertToTicketLabelInfo(selectedTickets: SelectedTicketInfo[], priceListWarnings: PriceWarningList[]): TicketLabelInfo[] {    
//     return selectedTickets.map((selectedTicket) => {
//         const warnings = priceListWarnings.find((warning) => warning.priceId === selectedTicket.pricegroup.PriceID);

//         return {
//             ticketId: selectedTicket.ticketId,
//             eventDateId: selectedTicket.pricegroup.EventDateID,
//             name: selectedTicket.ticket.Name,
//             quantity: 1,
//             pricegroup: selectedTicket.pricegroup,
//             warnings: warnings?.warnings,
//             isGA: selectedTicket.ticket.IsGA,
//             groupIds: [selectedTicket.ticketId]
//         };
//     });
// }

// function getTicketLabelsByPGAndFirstWarningType(ticketLabelInfos: TicketLabelInfo[]) {
//     const ticketsByPGIdAndFirstWarning: { [key: string]: TicketLabelInfo[]} = {}; 

//     ticketLabelInfos.forEach((selectedTicket) => { 
//         // Create a key based on pricegroup ID and first warning key
//         const key = `${selectedTicket.pricegroup.ID}_${selectedTicket.warnings ? selectedTicket.warnings[0].key : 0}`;

//         const ticketInfos: TicketLabelInfo[] = ticketsByPGIdAndFirstWarning[key] ?? []; // Get the ticketInfos array for the key or create a new one

//         ticketInfos.push(selectedTicket); 

//         ticketsByPGIdAndFirstWarning[key] = ticketInfos; // Update the ticketInfos array
//     });

//     return ticketsByPGIdAndFirstWarning;
// }

// /**
//  * Certains warning doivent être affichés seulement sur le ou les derniers billets d'un groupe de billets
//  * Ex.: Si on a 3 billets sur un tarifs par bon de 2 (Step of 2), on veut le warnings seulement sur le dernier billet pour pas faire peur au client.
//  * @param ticketLabelInfos 
//  * @returns 
//  */
// export function reduceTicketListWarningsForUX(ticketLabelInfos: TicketLabelInfo[]): TicketLabelInfo[] {
//     // Groupe les billets par type de "first warnings". (0 si pas de warnings)
//     const ticketsByPGAndFirstWarning = getTicketLabelsByPGAndFirstWarningType(ticketLabelInfos); 

//     // Construit un tableau de billets NON-TRIÉS en fonction des warnings
//     let modifiedTicketsArray: TicketLabelInfo[] = [];

//     // Traite chaque type/groupe de warnings avec la liste de billets qu'il contient
//     Object.entries(ticketsByPGAndFirstWarning).forEach(([_key, ticketInfos]) => {   
//         // On sort le warning du groupement en prenant le premier warning du premier billet
//         const firstTicketWarnings = ticketInfos[0].warnings;
//         const groupWarning = head(ticketInfos[0].warnings);

//         let goodTickets = []; // Tickets on which we will hide the warning
//         let warningTickets = []; // Tickets on which we will show the warning

//         if(groupWarning) {
//             // Selon le type de warning du groupe, on traite la liste de billets pour enlever les warnings gossants pour le client.

//             if(groupWarning.key === WarningKeyEnum.MISSING_QTY) {
//                 // Clean all tickets except the last one
//                 goodTickets = ticketInfos.slice(0, ticketInfos.length - 1); // All except last
//                 warningTickets = ticketInfos.splice(ticketInfos.length - 1, 1); // Last ticket

//             } else if(groupWarning.key === WarningKeyEnum.QTY_TO_REMOVE) {
//                 const qtyToRemove = firstTicketWarnings.reduce((acc, warning) => acc + warning.qtyToRemove, 0); // Sum all qtyRemoved

//                 let numberOfTicketToKeep = ticketInfos.length - qtyToRemove; // Keep the difference between qtyRemoved and ticketInfos.length
//                 if(numberOfTicketToKeep < 0) numberOfTicketToKeep = 0; // Protection, cannot remove more than what we have

//                 goodTickets = ticketInfos.slice(0, numberOfTicketToKeep); // Keep first to numberOfTicketToKeep tickets
//                 warningTickets = ticketInfos.splice(numberOfTicketToKeep, ticketInfos.length);
//             } else {
//                 warningTickets = ticketInfos;
//             }

//             //Removing warnings from good tickets
//             modifiedTicketsArray.push(...goodTickets.map((ticket: TicketLabelInfo) => { 
//                 return { ...ticket, warnings: [] }; 
//             }));
 
//             if(warningTickets.length > 0) {
//                 modifiedTicketsArray.push(...warningTickets.map((ticket: TicketLabelInfo) => { 
//                     return { ...ticket, warnings: [groupWarning] }; }));
//             }
//         }
//     });

//     //Assign warnings to the original ticket array
//     const retTicketLabelInfos: TicketLabelInfo[] = [];
//     ticketLabelInfos.forEach((ticket) => {
//         const foundTicket = modifiedTicketsArray.find((t) => t.ticketId === ticket.ticketId);
//         if(foundTicket) {
//             retTicketLabelInfos.push(Object.assign({}, ticket, { warnings: foundTicket.warnings }));
//         }
//         else 
//             retTicketLabelInfos.push(ticket);
//     });

//     return retTicketLabelInfos;
// }